module.exports = __webpack_public_path__ + "static/media/icon_kijkwijzer_discriminatie.1078bb00.svg";